import { Component, Input } from '@angular/core';

import { ColumnTable } from '../../models/column-model';
import { VatStatusEnum } from '../../../../../models';
import { DocumentTypesUppercaseEnum } from '../../../../modals/modals-common/link-document-modal/enums/ducument-types.enum';
import { TABLE_BADGE_CLASS } from 'projects/workspace/src/app/shared/constants/table-badge-class';

@Component({
  selector: 'rnpl-column-with-type-status',
  templateUrl: './column-with-type-status.component.html',
  styleUrls: ['./column-with-type-status.component.scss']
})
export class ColumnWithTypeStatusComponent {
  @Input() value: string | string[];
  @Input() column: ColumnTable;
  @Input() documentType: DocumentTypesUppercaseEnum;

  public vatBadgeClasses: { [key: string]: string } = {
    [VatStatusEnum.NA]: null,
    [VatStatusEnum.PENDING]: 'rnpl-badge--grey',
    [VatStatusEnum.NOT_VERIFIED]: 'rnpl-badge--grey',
    [VatStatusEnum.PASSED]: 'rnpl-badge--green',
    [VatStatusEnum.FAILED]: 'rnpl-badge--red'
  };

  public defaultClasses: { [key: string]: string } = TABLE_BADGE_CLASS;

  public getStatusClass(value: string): string {
    const normalizedValue: string = value && value.toLowerCase();

    return this.column.statusClass
      || (this.column.statusClasses && this.column.statusClasses[normalizedValue])
      || this.defaultClasses[normalizedValue];
  }
}
